import disbursementMdl from "./disbursement.mdl";

export default [...disbursementMdl];
